import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import GiftShopHome from "../components/giftshop/GiftShopHome";

export default () => {
  return (
    <Router>
      <Switch>
        <Route path="/gift-shop" component={GiftShopHome} />
        <Route path="/gift-shop/return-policy" component={GiftShopHome} />
      </Switch>
    </Router>
  );
};
